// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseTypeStatusModels {
    static getAttributeTypeMap() {
        return CaseTypeStatusModels.attributeTypeMap;
    }
}
CaseTypeStatusModels.discriminator = undefined;
CaseTypeStatusModels.additionalProperties = false;
CaseTypeStatusModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<CaseTypeStatusModel>"
    },
];
//# sourceMappingURL=caseTypeStatusModels.js.map